<div class="row">
  <div class="col">
    <div class="app-wrapper" [hidden]="settingsService.loading">
      <router-outlet></router-outlet>
      <div class="imprint">{{"GENERAL.IMPRINT_TEXT" | translate}}
        <a target="_blank"
        href="https://business.trustedshops.com/consent"> {{"GENERAL.IMPRINT_NAME" | translate}}</a>
      </div>
    </div>

    <div class="col">
      @if (getWindow().location.href.indexOf('/settings') > 0 && !settingsService.loading) {
        <div class="helping-hand-container"
          >
          <app-helping-hand></app-helping-hand>
        </div>
      }

      @if (!settingsService.loading && settingsService.user) {
        <div class="permanent-rating"
          (click)="settingsService.submitRating(true)">
          <p>{{"RATING.FOOTER_TEXT" | translate}} <a href="#" target="_blank">{{"RATING.FOOTER_RATE_US" | translate}}</a>
        </p></div>
      }
    </div>
  </div>

  @if (settingsService.showRatingCard && !settingsService.loading) {
    <mat-card class="app-rating">
      <app-rating></app-rating>
    </mat-card>
  }
</div>
<app-spinner [hidden]="!settingsService.loading"></app-spinner>

